import React, { useContext } from 'react';
import '../../App.css';
import Form from 'react-bootstrap/Form';
import { Link } from 'react-router-dom';
import { ref, set } from "firebase/database";
import { database } from '../../firebase-config.js';
import { useState } from "react";
import { User } from '../../UserContext.js';
import { auth } from "../../firebase-config.js";
import { onAuthStateChanged } from "firebase/auth";


export default function Sangue() {

    const [user, setUser] = useContext(User);

    onAuthStateChanged(auth, (currentUser) => {
        setUser(currentUser);
    });

    const [especie, setEspecie] = useState("");
    const [nomePet, setNomePet] = useState("");
    const [raca, setRaca] = useState("");
    const [vg, setVg] = useState("");
    const [dataColeta, setDataColeta] = useState("");
    const [dataValidade, setDataValidade] = useState("");

    async function writeUserData(especie, nomePet, raca, vg, dataColeta, dataValidade) {
        await set(ref(database, 'Bolsa/' + user.uid + '/' + Date.now()), {
            especie: especie,
            nomePet: nomePet,
            raca: raca,
            vg: vg,
            dataColeta: dataColeta,
            dataValidade: dataValidade
        });

        window.location.href = '/perfil';
    }

    const handleSubmit = event => {
        console.log('handleSubmit ran');
        event.preventDefault(); // prevent page refresh

        if (especie === '') {
            console.log('especie is empty');
            //TODO: Deixar vermelho e dizer q tem q preencher
            return;
        }
        if (nomePet === '') {
            console.log('nomePet is empty');
            //TODO: Deixar vermelho e dizer q tem q preencher
            return;
        }
        if (raca === '') {
            console.log('raca is empty');
            //TODO: Deixar vermelho e dizer q tem q preencher
            return;
        }
        if (vg === '') {
            console.log('vg is invalid');
            //TODO: Deixar vermelho e dizer q tem q preencher e checar vg direito
            return;
        }

        // access input values here
        console.log('especie ', especie);
        console.log('nomePet ', nomePet);
        console.log('raca ', raca);
        console.log('vg', vg);

        writeUserData(especie, nomePet, raca, vg, dataColeta, dataValidade);
    };

    return <>
        <body className='sangue'>
            <h1 className='title'>Cadastro Bolsa de Sangue</h1>
            <Form onSubmit={handleSubmit}>
                <Form.Group className="formNomeTutor" controlId="formGroupTransfusao">
                    <Form.Label> Esp&eacute;cie </Form.Label>
                    <Form.Select aria-label="�" onChange={event => setEspecie(event.target.value)}>
                        <option> </option>
                        <option value="Cachorro">Cachorro</option>
                        <option value="Gato">Gato</option>
                    </Form.Select>
                </Form.Group>

                <Form.Group className='formNomeTutor' controlId="formGroupNomeTutor">
                    <Form.Label>Nome do Pet: </Form.Label>
                    <Form.Control
                        type="text"
                        onChange={event => setNomePet(event.target.value)} />
                </Form.Group>

                <Form.Group className='formRaca' controlId="formGroupRaca">
                    <Form.Label> Ra&ccedil;a: </Form.Label>
                    <Form.Control
                        type="text"
                        onChange={event => setRaca(event.target.value)} />
                </Form.Group>

                <Form.Group className='formIdade' controlId="formGroupIdade">
                    <Form.Label>VG %: </Form.Label>
                    <Form.Control
                        type="text"
                        onChange={event => setVg(event.target.value)} />
                </Form.Group>

                <Form.Group className='formIdade' controlId="formGroupIdade">
                    <Form.Label>Data da coleta: </Form.Label>
                    <Form.Control
                        type="date"
                        onChange={event => setDataColeta(event.target.value)} />
                </Form.Group>

                <Form.Group className='formIdade' controlId="formGroupIdade">
                    <Form.Label>Data de validade</Form.Label>
                    <Form.Control
                        type="date"
                        onChange={event => setDataValidade(event.target.value)} />
                </Form.Group>

                <div class="center">
                    <button className='btn--enviar' type="submit">Enviar</button>
                </div>
            </Form>
        </body>
    </>;

}